import React from 'react'
import CodieImg from '../Assets/codie_transparent.png'

const Footer = () => {
    return (
        <div className='container-bg '>
            <div className='footer-main'>
                <div className='footer-top'>
                    <div>
                        <h3>Codie is your personal Interview prep buddy</h3>
                        <a href="https://chrome.google.com/webstore/detail/codie/alokfiajmmedmneninfkldildipgjemf/" target='_blank' rel="noreferrer"><button>Try now</button></a>
                    </div>
                    <img src={CodieImg} alt="codie" />
                </div>
                <hr />
                <div className='footer-bottom'>
                    <p>&#169;2023. All Rights Reserved</p>
                    <p className='footer-bottom-disclaimer'>Disclaimer: Codie is powered using AI, and comes with inherent limitations. The answers provided may not be always accurate and we don't take any responsibility for the results it gives.</p>
                </div>
            </div>
        </div>
    )
}

export default Footer